import {
  DuplicateUsernameFailure,
  Profile,
  UsernameBlackListFailure,
} from '@fantaz/shared/data-access/models';
import { FormError } from '@fantaz/shared/utils';
import { Action, createReducer, on } from '@ngrx/store';
import * as ProfileActions from './profile.actions';

export const PROFILE_FEATURE_KEY = 'profile';

export interface ProfileState {
  data?: Profile | null;
  loaded: boolean; // has the Profile list been loaded
  error?: string | null; // last known error (if any)
  updating: boolean;
  updatingError?: string | null;
  formErrors?: FormError | null;
}

export interface ProfilePartialState {
  readonly [PROFILE_FEATURE_KEY]: ProfileState;
}

export const initialState: ProfileState = {
  // set initial required properties
  loaded: false,
  updating: false,
};

const profileReducer = createReducer(
  initialState,
  on(ProfileActions.loadProfile, (state) => ({
    ...state,
    data: null,
    loaded: false,
    error: null,
    updating: false,
    updatingError: null,
  })),
  on(ProfileActions.loadProfileSuccess, (state, { profile }) => ({
    ...state,
    data: profile,
    loaded: true,
  })),
  on(ProfileActions.loadProfileFailure, (state, { error }) => ({
    ...state,
    error,
  })),

  // ***************************************************************************
  // ** Update Profile
  // ***************************************************************************
  on(ProfileActions.update, (state) => ({
    ...state,
    updating: true,
    formError: null,
  })),
  on(ProfileActions.updateProfileSuccess, (state, { profile }) => ({
    ...state,
    updating: false,
  })),
  on(ProfileActions.updateProfileFailure, (state, { error }) => ({
    ...state,
    updating: false,
    ...(error instanceof UsernameBlackListFailure ||
    error instanceof DuplicateUsernameFailure
      ? {
          formErrors: {
            username: {
              [error.key]: true,
            },
          },
        }
      : {}),
  })),
);

export function reducer(state: ProfileState | undefined, action: Action) {
  return profileReducer(state, action);
}
